@switch (type) {
    @case ("chart") {
        <key-analytics-chart-graph [data]="data" (onLoad)="onLoad.emit($event)" (onMeasureSelection)="onMeasureSelection.emit($event)"></key-analytics-chart-graph>
    }
    @case ("pie") {
        <key-analytics-chart-pie [data]="data" (onLoad)="onLoad.emit($event)" (onMeasureSelection)="onMeasureSelection.emit($event)"></key-analytics-chart-pie>
    }
    @case ("stat") {
        <key-analytics-chart-stat [data]="data" (onLoad)="onLoad.emit($event)" [size]="size" (onMeasureSelection)="onMeasureSelection.emit($event)"></key-analytics-chart-stat>
    }
    @default {
        <kui-alert-panel [message]="'ANALYTICS.ERRORS.UNSUPPORTED_CHART_TYPE' | translate: { type: type | titlecase }"></kui-alert-panel>
    }
}
